import React from 'react';
import {
  CheckCircleIcon,
  DotsHorizontalIcon,
  EyeIcon,
  InformationCircleIcon,
  ShieldExclamationIcon,
  UserRemoveIcon,
  XCircleIcon,
} from '@heroicons/react/solid';
import {
  Button,
  ButtonGroup,
  Card,
  Dropdown,
  FormCheck,
  OverlayTrigger,
  Tooltip,
  Image,
} from 'react-bootstrap';
import { ToggleAction } from './ToggleAction';
import { StorageModule } from '@vlinder-web/storage-module-react';

import * as S from './styles';

const capitalizeFirstLetter = (string: any) =>
  string[0].toUpperCase() + string.slice(1);

const getFirstLetterOfEachWord = (text: any) => {
  try {
    let Rtext = text && text !== '' ? text?.match(/\b\w/g).join('') : '';
    console.log(`Rtext`, Rtext, Rtext.length);
    if (Rtext && Rtext.length > 2) {
      return Rtext.substring(0, 2);
    } else {
      return Rtext;
    }
  } catch (error) {}
};

export const DomainTableRow = (props: any) => {
  const {
    id,
    verified,
    status,
    image,
    name,
    ultReInvite,
    email,
    dateCreated,
    isSelected,
    selectUser,
    deleteUsers,
    onTogglePress,
    onViewDetailClick,
    onViewClick,
    role,
  } = props;
  const VerifiedIcon = verified ? CheckCircleIcon : InformationCircleIcon;
  const storageSrv = StorageModule?.getInstance();
  const userProfile = storageSrv.get('myProfile', 'session');

  const variantColor =
    status === 'active'
      ? '#00AB08'
      : status === 'created'
      ? '#FE8D01'
      : status === 'suspended'
      ? '#DC3545'
      : status === 'verified'
      ? '#691783'
      : '#0000FF';

  const statusVariant =
    status === 'active'
      ? 'success'
      : status === 'created'
      ? 'warning'
      : status === 'invited'
      ? 'purple'
      : status === 'verified'
      ? 'purple'
      : status === 'suspended'
      ? 'danger'
      : 'primary';

  const onToggle = (key: string) => {
    if (key === 'view') {
      onViewClick && onViewClick(id);
    } else if (key === 're-invite') {
      ultReInvite && ultReInvite(id);
    } else {
      onTogglePress && onTogglePress(key, id);
    }
  };

  const renderCircle = (roles: any) => {
    const colors = ['008000', '800080', 'A52A2A', 'FF7F50', 'd2d2d2', '29A6A6'];

    const output: any = [];

    const returnImg = () => {
      Array.isArray(roles) &&
        roles?.forEach((item, index) => {
          output.push(
            <li
              className="d-inline-block"
              style={{ marginLeft: index === 0 ? '0px' : '-19px' }}
            >
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip className="m-0">{item?.name}</Tooltip>}
              >
                <Image
                  style={{ width: '40px' }}
                  className="img-40 rounded-circle"
                  src={`https://ui-avatars.com/api/?name=${item?.img}&background=${colors[index]}&color=fff`}
                />
              </OverlayTrigger>
            </li>
          );
        });
      return output;
    };

    return (
      <div
        className="roleAvatar"
        style={{ width: '100%', inlineSize: 'max-content' }}
      >
        <ul style={{ paddingLeft: '0px' }}>{returnImg()}</ul>
      </div>
    );
  };

  return (
    <tr className="border-bottom user-table">
      <td>
        <FormCheck type="checkbox" className="dashboard-check">
          <FormCheck.Input
            id={`user-${id}`}
            checked={isSelected}
            onChange={() => selectUser(id)}
          />
          <FormCheck.Label htmlFor={`user-${id}`} />
        </FormCheck>
      </td>
      <td>
        <Card.Link className="d-flex align-items-center">
          {image ? (
            <Image src={image} className="avatar rounded-circle me-3" />
          ) : (
            <div className="avatar d-flex align-items-center justify-content-center fw-bold rounded bg-secondary me-3">
              <span>{name && getFirstLetterOfEachWord(name)}</span>
            </div>
          )}
          <div className="d-block">
            <span
              className="fw-bold"
              style={{ maxWidth: '200px', overflow: 'auto', display: 'block' }}
            >
              {name}
            </span>
          </div>
        </Card.Link>
      </td>

      <td>
        <ToggleAction status={status} onTogglePress={onToggle} />
        {/* 
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip className="m-0">Delete</Tooltip>}
        >
          <Card.Link
            className="ms-2"
            onClick={() => deleteUsers && deleteUsers(id)}
          >
            <XCircleIcon className="icon icon-xs text-danger" />
          </Card.Link>
        </OverlayTrigger> */}
      </td>
      <td>
        <span className="fw-normal">{email}</span>
      </td>
      <td className="mw-20">
        <span className="fw-normal d-flex align-items-center">
          {/* {role} */}
          {renderCircle(role)}
        </span>
      </td>
      <td>
        <span className={`fw-normal `}>
          {/* <S.ButtonComp
            className={`rounded-pill btn-sm`}
            color={variantColor}
          > */}
          {status && capitalizeFirstLetter(status)}
          {/* </S.ButtonComp> */}
        </span>
      </td>
      <td>
        <span className="fw-normal">{dateCreated}</span>
      </td>

      {/* <td>
        {userProfile?.email !== email ? (
          <>
          {userRole?.name === "owner" && (
            <OverlayTrigger
            placement="top"
            overlay={<Tooltip className="m-0">Delete</Tooltip>}
            >
                <Card.Link
                className="ms-2"
                onClick={() => deleteUsers && deleteUsers(id)}
                >
                <XCircleIcon className="icon icon-xs text-danger" />
                </Card.Link>
                </OverlayTrigger>
                )}
                </>
                ) : null}
              </td> */}
    </tr>
  );
};
